import { render, staticRenderFns } from "./ServiceTypezhongfeng6month.vue?vue&type=template&id=b1891e12&scoped=true"
import script from "./ServiceTypezhongfeng6month.vue?vue&type=script&lang=js"
export * from "./ServiceTypezhongfeng6month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1891e12",
  null
  
)

export default component.exports